import type { AssistantStepType } from './types'

export type AssistantErrorCode =
  | 'ASSISTANT_UNKNOWN'
  | 'ASSISTANT_PROJECT_MISSING'
  | 'ASSISTANT_PLANNER_UNAVAILABLE'
  | 'ASSISTANT_PLANNER_INVALID_RESPONSE'
  | 'ASSISTANT_EXPORT_FAILED'
  | 'ASSISTANT_EXPORT_UNSUPPORTED'
  | 'ASSISTANT_REFERENCE_IMAGE_GENERATION_FAILED'
  | 'ASSISTANT_BGM_GENERATION_FAILED'

export function classifyAssistantError(
  error: unknown,
  context?: { stepType?: AssistantStepType },
): AssistantErrorCode {
  const message = error instanceof Error ? error.message : String(error)

  if (/当前没有已打开的项目|项目上下文/i.test(message)) {
    return 'ASSISTANT_PROJECT_MISSING'
  }
  if (
    context?.stepType === 'generate_reference_images' ||
    context?.stepType === 'save_generated_images_to_media'
  ) {
    return 'ASSISTANT_REFERENCE_IMAGE_GENERATION_FAILED'
  }
  if (context?.stepType === 'generate_bgm') {
    return 'ASSISTANT_BGM_GENERATION_FAILED'
  }
  if (context?.stepType === 'start_export') {
    if (/不支持|codec|编码|浏览器/i.test(message)) {
      return 'ASSISTANT_EXPORT_UNSUPPORTED'
    }
    return 'ASSISTANT_EXPORT_FAILED'
  }
  if (/planner request failed|Missing VITE_QIANFAN_API_KEY|AI 服务未配置|OLLAMA_HOST|NVIDIA_API_KEY/i.test(message)) {
    return 'ASSISTANT_PLANNER_UNAVAILABLE'
  }
  if (/Planner response did not contain message content|Invalid planner JSON|schema/i.test(message)) {
    return 'ASSISTANT_PLANNER_INVALID_RESPONSE'
  }
  return 'ASSISTANT_UNKNOWN'
}